import { render, staticRenderFns } from "./RelationshipRefusalBanner.vue?vue&type=template&id=77c2c4f8&scoped=true"
import script from "./RelationshipRefusalBanner.vue?vue&type=script&lang=js"
export * from "./RelationshipRefusalBanner.vue?vue&type=script&lang=js"
import style0 from "./RelationshipRefusalBanner.vue?vue&type=style&index=0&id=77c2c4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2c4f8",
  null
  
)

export default component.exports